import { render, staticRenderFns } from "./CouponTypeSelect.vue?vue&type=template&id=2d052daa&scoped=true"
import script from "./CouponTypeSelect.vue?vue&type=script&lang=js"
export * from "./CouponTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d052daa",
  null
  
)

export default component.exports